<template>
  <div>
  <modal :title="titleName" :show="showModal" @close="closeModal()">
    <div class="content txt-center" slot="content">
      <img width="250" src="@/assets/img/adblock.svg" class="" />
      <p style="padding-bottom:10px">
        Para o funcionamento correto da ferramenta você precisa desativar o bloqueador de anúncio!
      </p>
    </div>
    <div class="action flex center" slot="action">
      <div class="buttons center">
        <a
          @click="acceptModal()"
          class="button primary medium"
          :class="{ unusual: unusual == 'accept' }"
        >
          Atualizar
        </a>
      </div>
    </div>
  </modal>
  <div class="adsbygoogle ad anuncio facebook fbads" id="ad-detector"></div>
  </div>
</template>

<script>
import Modal from "./Modal";

export default {
  name: "modal-ad-block-detect",
  props: {
    titleName: {
      required: false,
      default: "Bloqueador de anúncio detectado!"
    },
    unusual: {
      required: false,
      default: "false"
    }
  },
  components: {
    Modal
  },
  data() {
    return {
      showModal: false,
      seenGuide: {},
      haveAdBlock: false,
    };
  },
  watch: {
    haveAdBlock(value) {
      console.log('value', value)
      this.showModal = value
    }
  },
  mounted() {
    setTimeout(this.detectAdBlock(), 1500);
  },
  methods: {
    detectAdBlock() {
      // add test element and get its styles
      var adElement = document.getElementById('ad-detector');
      var adElementStyle = window.getComputedStyle(adElement, null);

      if(adElementStyle.display === 'none') {
        // Adblock enabled
        this.haveAdBlock = true
      } else {
        // Adblock disabled
        this.haveAdBlock = false
      }
    },
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", true);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.action {
  margin-top: 30px;
  .button {
    margin-left: 10px;
  }
}
</style>
